import { makeStyles } from "@material-ui/core"
import logo from "../../images/branding/invoiage/invoiage_logo_only.png"
export default function InvoiageLogo({height, width}) {

  const useStyles= makeStyles(theme => ({
    logo: {
      height: height || 48,
      width: width || 48
    }
  }))
  const styles=useStyles()

  return (
    <img className={styles.logo} src={logo} />
  )
}